import { render, staticRenderFns } from "./medicaments.vue?vue&type=template&id=5b0512e2&"
import script from "./medicaments.vue?vue&type=script&lang=js&"
export * from "./medicaments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports